import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledPromotionBannerTimer = styled.div`
  /* background-color: ${baseVariables.color['neutral10']} !important; */
  .timer-container {
    @media ${baseVariables.mediaQuery.lg} {
      border-left: ${toRem(1)} solid ${baseVariables.color['neutral30']};
    }
  }
  .promo-timer {
    padding: ${toRem(12)} !important;
    margin-bottom: ${toRem(8)};
    background: #303030;
    color: ${baseVariables.color['base20']};
    border-radius: ${toRem(14)};
  }
  .promotions-timer {
    p {
      padding: 0;
    }
  }
`;
